var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.7,
    fill: "#26282F",
    stroke: "#363943",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C10.0111 6 9.0444 6.29324 8.22215 6.84265C7.39991 7.39206 6.75904 8.17295 6.3806 9.08658C6.00217 10.0002 5.90315 11.0055 6.09608 11.9755C6.289 12.9454 6.76521 13.8363 7.46447 14.5355C8.16373 15.2348 9.05465 15.711 10.0246 15.9039C10.9945 16.0969 11.9998 15.9978 12.9134 15.6194C13.827 15.241 14.6079 14.6001 15.1573 13.7779C15.7068 12.9556 16 11.9889 16 11C16 10.3434 15.8707 9.69321 15.6194 9.08658C15.3681 8.47995 14.9998 7.92876 14.5355 7.46447C14.0712 7.00017 13.52 6.63188 12.9134 6.3806C12.3068 6.12933 11.6566 6 11 6V6ZM11.5 13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5C10.8674 13.5 10.7402 13.4473 10.6464 13.3536C10.5527 13.2598 10.5 13.1326 10.5 13V10.5C10.5 10.3674 10.5527 10.2402 10.6464 10.1464C10.7402 10.0527 10.8674 10 11 10C11.1326 10 11.2598 10.0527 11.3536 10.1464C11.4473 10.2402 11.5 10.3674 11.5 10.5V13ZM11 9.5C10.9011 9.5 10.8044 9.47068 10.7222 9.41573C10.64 9.36079 10.5759 9.2827 10.5381 9.19134C10.5002 9.09998 10.4903 8.99945 10.5096 8.90245C10.5289 8.80546 10.5765 8.71637 10.6464 8.64645C10.7164 8.57652 10.8055 8.5289 10.9025 8.50961C10.9994 8.49031 11.1 8.50022 11.1913 8.53806C11.2827 8.5759 11.3608 8.63999 11.4157 8.72221C11.4707 8.80444 11.5 8.90111 11.5 9C11.5 9.13261 11.4473 9.25979 11.3536 9.35355C11.2598 9.44732 11.1326 9.5 11 9.5Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8d701ff276d68f12d9bc4a638573575b.svg";
export { ForwardRef as ReactComponent };